import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../Services/Api";

// initialize client IP from local storage
const clientIP = localStorage.getItem('rfc_client_ip')
    ? localStorage.getItem('rfc_client_ip')
    : null

const initialState = {
    loading: false,
    data: [],
    error: ''
}

// fetch data from api
export const fetchRecentlyAddedTokens = createAsyncThunk('fetchRecentlyAddedTokens', async () => {
    return api
        .get(`coins?per_page=3&direction=DESC&sort_key=approved_at&ip_address=${clientIP}&page=1`)
        .then((response) => response.data.payload)
})

export const recentlyAddedToknesSlice = createSlice({
    name: "recentlyAddedToknes",
    initialState,
    extraReducers: (builder) => {
        builder.addCase(fetchRecentlyAddedTokens.pending, (state) => {
            state.loading = true
        })
        builder.addCase(fetchRecentlyAddedTokens.fulfilled, (state, action) => {
            state.loading = false
            state.data = action.payload.data
            state.error = ''
        })
        builder.addCase(fetchRecentlyAddedTokens.rejected, (state, action) => {
            state.loading = false
            state.data = []
            state.error = action.error.message
        })
    }
});

export default recentlyAddedToknesSlice.reducer